import { render, staticRenderFns } from "./AttendanceFloatBtns.vue?vue&type=template&id=aaae1aac&"
import script from "./AttendanceFloatBtns.vue?vue&type=script&lang=js&"
export * from "./AttendanceFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports